import axios from 'axios';

// URL base dell'API per le statistiche, recuperato dall'env file
const STATISTICHE_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'statistiche/comune';

const headers = { 'Content-Type': 'application/json' };

class StatisticheService {

    /**
     * Recupera le statistiche di un comune specifico.
     * Effettua una chiamata GET a `/statistiche/comune/{comId}`.
     * 
     * @param {number} comId - L'ID del comune di cui recuperare le statistiche.
     * @returns {Promise} - Una promessa contenente i dati delle statistiche del comune.
     */
    getStatistiche(comId) {
        return axios.get(`${STATISTICHE_REST_API_URL}/${comId}`);
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const statisticheServiceInstance = new StatisticheService();
export default statisticheServiceInstance;
